import React, { useState } from 'react'
import { Badge, Pane, Text } from "evergreen-ui";
import { FaRegMoneyBillAlt } from 'react-icons/fa'

const DetailClassInterviweLevel1 = ({ DataRegister }) => {
    const validCodes = [
        "1101",
        "1102",
        "1103",
        "1106",
        "1110",
        "1207",
        "1208",
        "1301",
        "1302",
        "1304",
        "1310",
    ];
    return (
        <>

            {
                (DataRegister.ROB_ID === "183" || DataRegister.ROB_ID === "184") ?
                    validCodes.includes(DataRegister.Major_MAJOR_ID) ?
                        (
                            <>
                                <Pane
                                    color="#ffffff"
                                    backgroundColor="#ff0000"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={16}
                                    fontFamily=""
                                    fontWeight={700}
                                    marginTop={10}
                                    display="flex" alignItems="center" justifyContent="center"
                                >
                                    <Text fontWeight={700} style={{ color: "#ffffff" }}>
                                        * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                    </Text>
                                </Pane>

                                <div className="d-flex">
                                    <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                    <div> {DataRegister.Major_MAJOR_CLASSROOM}</div>
                                </div>
                                <div className="d-flex">
                                    <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                    <div> {DataRegister.Major_MAJOR_CLASSROOM2} </div>
                                </div>
                                <div className="d-flex">
                                    <Text fontWeight={600}>
                                        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                        &nbsp;&nbsp; &nbsp;
                                    </Text>
                                    <div> {DataRegister.Major_MAJOR_CLASSROOM3} </div>
                                </div>
                            </>
                        )
                        :
                        (

                            <Text color="#fa0000ff" fontWeight={700}>
                                ไม่ต้องเข้ารับการสอบสัมภาษณ์ จะประกาศรายชื่อผู้ผ่านการคัดเลือก วันที่ 9 เมษายน 2569 เวลา 18.00 น.
                            </Text>

                        )
                    :
                    (
                        <>
                            <Pane
                                color="#ffffff"
                                backgroundColor="#ff0000"
                                height="100%"
                                paddingY={4}
                                paddingX={5}
                                fontSize={16}
                                fontFamily=""
                                fontWeight={700}
                                marginTop={10}
                                display="flex" alignItems="center" justifyContent="center"
                            >
                                <Text fontWeight={700} style={{ color: "#ffffff" }}>
                                    * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                </Text>
                            </Pane>
                            <div className="d-flex">
                                <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                <div> {DataRegister.Major_MAJOR_CLASSROOM}</div>
                            </div>
                            <div className="d-flex">
                                <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                <div> {DataRegister.Major_MAJOR_CLASSROOM2} </div>
                            </div>
                            <div className="d-flex">
                                <Text fontWeight={600}>
                                    &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                    &nbsp;&nbsp; &nbsp;
                                </Text>
                                <div> {DataRegister.Major_MAJOR_CLASSROOM3} </div>
                            </div>
                        </>
                    )
            }


        </>

    )
}

export default DetailClassInterviweLevel1